import * as Yup from 'yup';

const TagsValidationSchemaconst = Yup.object().shape({    
    name: Yup.string().required('Name is required!').max(100, "Maxlenght 100 character.")      
});




export default TagsValidationSchemaconst;